<nav id="nav-container" class="d-flex align-items-center justify-content-between">
  <div class="d-flex">
    <img src="assets/logo-1280-206.png" class="logo">

    <ng-container *ngIf="refUserIsStaff">
      <button mat-icon-button [matMenuTriggerFor]="menu" class="me-3">
        <mat-icon [matBadge]="notifications.length" [matBadgeHidden]="!notifications.length">notifications</mat-icon>
      </button>

      <mat-menu #menu="matMenu">
        <ng-container *ngIf="notifications.length">
          <ng-container *ngFor="let item of notifications">
            <a [routerLink]="item.routerLink" [queryParams]="item.queryParams">
              <button mat-menu-item class="anchor">{{ item.label }}</button>
            </a>
          </ng-container>
        </ng-container>

        <ng-container *ngIf="!notifications.length">
          <p mat-menu-item>You have no notifications</p>
        </ng-container>
      </mat-menu>
    </ng-container>
  </div>

  <div>
    <span routerLink="/logout" id="my-account-menu-trigger" class="anchor">Logout</span>
  </div>
</nav>
